import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const KarenProfile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/creators', { replace: true });
  }, [navigate]);

  return null;
};

export default KarenProfile;
